import { useSetAviaryTheme } from "@aviary/utils/useSetAviaryTheme";

const useIsDS4Enabled = () => {
  const { isDS4Visuals } = useSetAviaryTheme();

  return isDS4Visuals;
};

export { useIsDS4Enabled };
